import {useEffect, useRef, useState} from "react";
import {LuArrowDownUp} from "react-icons/lu";

export const productSortOptions = [
  ["name-asc", "A-Z"],
  ["name-desc", "Z-A"],
  ["price-desc", "Precio mayor a menor"],
  ["price-asc", "Precio menor a mayor"],
];
export const ProductSort = ({value, onChange}) => {
  const [open, setOpen] = useState(false);
  const root = useRef(null), trigger = useRef(null), items = useRef([]);
  const close = () => {setOpen(false); trigger.current?.focus();};
  useEffect(() => {
    if (!open) return;
    items.current[productSortOptions.findIndex(([id]) => id === value)]?.focus();
    const outside = event => {if (!root.current?.contains(event.target)) setOpen(false);};
    document.addEventListener("pointerdown", outside);
    return () => document.removeEventListener("pointerdown", outside);
  }, [open, value]);
  const keyboard = event => {
    const index = items.current.indexOf(document.activeElement);
    const next = event.key === "ArrowDown" ? (index + 1) % 4 : event.key === "ArrowUp" ? (index + 3) % 4 : event.key === "Home" ? 0 : event.key === "End" ? 3 : null;
    if (next != null) {event.preventDefault(); items.current[next]?.focus();}
    if (event.key === "Escape") {event.preventDefault(); close();}
    if (event.key === "Tab") close();
  };
  return <div className="productCatalogSort" ref={root}>
    <button ref={trigger} type="button" aria-label="Ordenar por" aria-haspopup="menu" aria-expanded={open} onClick={() => setOpen(previous => !previous)} onKeyDown={event => {if (event.key === "ArrowDown" || event.key === "ArrowUp") {event.preventDefault();setOpen(true);}}}><LuArrowDownUp aria-hidden="true"/>Ordenar por</button>
    {open && <div className="productSortMenu" role="menu" tabIndex={-1} aria-label="Orden de productos" onKeyDown={keyboard}>{productSortOptions.map(([id,label],index) => <button key={id} ref={node => {items.current[index] = node;}} type="button" role="menuitemradio" aria-checked={id === value} onClick={() => {onChange(id); close();}}>{label}</button>)}</div>}
  </div>;
};
